import React from 'react';
import PageHeader from '../../components/PageHeader';
import './crm-foundation.css';

// WO-2934: wrapper that puts a CRM page body on the Look E tone tokens and, when a title is given, the shared PageHeader.
export default function CrmPage({ title, description, children }) {
  return (
    <div className="crm-page" data-testid="crm-page">
      {title && <div className="crm-page-header"><PageHeader title={title} description={description} /></div>}
      {children}
    </div>
  );
}

// extraProps are handed to the wrapped page (the tabbed Succession page uses hideTitle so only the shared header shows).
export function withCrmPage(Component, title, description, extraProps) {
  const Wrapped = (props) => <CrmPage title={title} description={description}><Component {...props} {...extraProps} /></CrmPage>;
  Wrapped.displayName = `CrmPage(${Component.displayName || Component.name || 'Page'})`;
  return Wrapped;
}
